import { GridRenderCellParams } from '@mui/x-data-grid-premium';
import DataGridCell from 'components/common/DataGridCell';
import { IsTenantAdministrator } from 'components/helpers/IsTenantAdministrator';

export function adminCell<T>(params: GridRenderCellParams<T>) {
  return (
    <IsTenantAdministrator>
      <DataGridCell content={params.value as string} />
    </IsTenantAdministrator>
  );
}
